export default __webpack_public_path__ + "static/media/floralServiceImg_02.acf4ec80.jpg";